import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

/**
 * Settings screens that are surfaced as cards on the Applications screen
 * instead of living in the Settings submenu. Feature flags and account types
 * are copied verbatim from `config/sidebarItems/settings.js` so that moving a
 * screen here never changes who is able to see it. Role based access keeps
 * being enforced by the `roles` declared on each route.
 *
 * `logo` points to a Figma-matched icon in
 * public/dashboard/images/integrations/; `icon` is the fluent-icon fallback
 * used for the items that don't have a custom logo yet.
 */
const internalApplications = accountId => [
  {
    id: 'bulk-actions',
    source: 'internal',
    icon: 'automation',
    logo: 'bulk-actions.png',
    nameKey: 'INTEGRATION_APPS.ITEMS.BULK_ACTIONS.NAME',
    descriptionKey: 'INTEGRATION_APPS.ITEMS.BULK_ACTIONS.DESCRIPTION',
    toState: frontendURL(`accounts/${accountId}/settings/bulk-actions/list`),
    toStateName: 'bulk_actions_list',
    featureFlag: FEATURE_FLAGS.AUTOMATIONS,
    accountTypes: ['account', 'subaccount'],
  },
  {
    id: 'agent-bot-management',
    source: 'internal',
    icon: 'robot',
    logo: 'bots.png',
    nameKey: 'INTEGRATION_APPS.ITEMS.AGENT_BOT_MANAGEMENT.NAME',
    descriptionKey: 'INTEGRATION_APPS.ITEMS.AGENT_BOT_MANAGEMENT.DESCRIPTION',
    toState: frontendURL(
      `accounts/${accountId}/settings/agent-bot-management/list`
    ),
    toStateName: 'agent_bot_management_list',
    featureFlag: FEATURE_FLAGS.AGENT_BOT_MANAGEMENT,
    accountTypes: ['account', 'subaccount'],
  },
  {
    id: 'cadencias',
    source: 'internal',
    icon: 'flash-settings',
    logo: 'cadencias.png',
    nameKey: 'INTEGRATION_APPS.ITEMS.CADENCIAS.NAME',
    descriptionKey: 'INTEGRATION_APPS.ITEMS.CADENCIAS.DESCRIPTION',
    toState: frontendURL(`accounts/${accountId}/settings/cadencias`),
    toStateName: 'cadencia_settings_index',
    accountTypes: ['account', 'subaccount'],
  },
  {
    id: 'events',
    source: 'internal',
    icon: 'flash-on',
    logo: 'events.png',
    nameKey: 'INTEGRATION_APPS.ITEMS.EVENTS.NAME',
    descriptionKey: 'INTEGRATION_APPS.ITEMS.EVENTS.DESCRIPTION',
    toState: frontendURL(`accounts/${accountId}/settings/events`),
    toStateName: 'events_settings_index',
  },
  {
    id: 'closing-reasons',
    source: 'internal',
    icon: 'chat-off',
    logo: 'closing-reasons.png',
    nameKey: 'INTEGRATION_APPS.ITEMS.CLOSING_REASONS.NAME',
    descriptionKey: 'INTEGRATION_APPS.ITEMS.CLOSING_REASONS.DESCRIPTION',
    toState: frontendURL(`accounts/${accountId}/settings/closing-reasons/list`),
    toStateName: 'closingreasons_list',
    accountTypes: ['account', 'subaccount'],
  },
  {
    id: 'audit-log',
    source: 'internal',
    icon: 'key',
    logo: 'audit-log.png',
    nameKey: 'INTEGRATION_APPS.ITEMS.AUDIT_LOG.NAME',
    descriptionKey: 'INTEGRATION_APPS.ITEMS.AUDIT_LOG.DESCRIPTION',
    toState: frontendURL(`accounts/${accountId}/settings/audit-log/list`),
    toStateName: 'auditlogs_list',
    featureFlag: FEATURE_FLAGS.AUDIT_LOGS,
    accountTypes: ['account', 'subaccount'],
  },
];

/**
 * Route names owned by the Applications screen. Used by the Settings submenu
 * so the "Applications" entry stays highlighted while the user is on one of
 * the screens reachable only from there.
 */
export const APPLICATION_ROUTE_NAMES = [
  'bulk_actions_list',
  'bulk_actions_report',
  'bulk_actions_wrapper',
  'agent_bot_management_list',
  'cadencia_settings_index',
  'events_settings_index',
  'closingreasons_list',
  'auditlogs_list',
];

export const getInternalApplications = internalApplications;

export default internalApplications;
